// extracted by mini-css-extract-plugin
module.exports = {"title":"Account_title__udqNS","centered":"Account_centered__5CaVP"};